<script setup>
import { ref } from "vue";

const props = defineProps([
  "modelValue",
  "filter",
  "type",
  "required",
  "placeholder",
  "disabled",
  "max",
  "label",
  "icon",
  "error",
  "autocomplete",
  "spellcheck",
  "autocapitalize",
]);
const emit = defineEmits(["update:modelValue"]);

const input = ref(null);
const ov = ref(null);
const oss = ref(null);
const ose = ref(null);
const handlers = ref({
  input: handleInput,
  keyup: handleInput,
  keydown: handleInput,
  select: handleInput,
  contextmenu: handleInput,
  drop: handleInput,
});

function handleInput(event) {
  if (props.filter == "username") {
    if (/^[a-zA-Z0-9_ ]*$/i.test(input.value.value)) {
      ov.value = input.value.value
        .replace(/-+/g, "")
        .replace(/\s+/g, "_")
        .replace(/\_\_+/g, "_")
        .replace(/^_+/, "");
      oss.value = input.value.selectionStart;
      ose.value = input.value.selectionEnd;
      input.value.value = ov.value;
      emit("update:modelValue", ov.value);
    } else if (ov.value) {
      input.value.value = ov.value;
      emit("update:modelValue", ov.value);
      input.value.setSelectionRange(oss.value, ose.value);
    } else {
      input.value.value = "";
      emit("update:modelValue", "");
    }
  } else if (props.filter == "phone") {
    if (/^[0-9+()-]*$/i.test(input.value.value)) {
      ov.value = input.value.value
        .replace(/\s+/g, "-")
        .replace(/\-\-+/g, "-")
        .replace(/^-+/, "");
      oss.value = input.value.selectionStart;
      ose.value = input.value.selectionEnd;
      input.value.value = ov.value;
      emit("update:modelValue", ov.value);
    } else if (ov.value) {
      input.value.value = ov.value;
      emit("update:modelValue", ov.value);
      input.setSelectionRange(oss.value, ose.value);
    } else {
      input.value.value = "";
      emit("update:modelValue", "");
    }
  } else {
    emit("update:modelValue", event.target.value);
  }
}
</script>

<template>
  <div class="flex w-full flex-col gap-2 normal-case">
    <label 
      class="text-text-base text-body-sm font-body font-medium uppercase tracking-wider" 
      v-if="label && modelValue && modelValue.length > 0">
      {{ label }}
    </label>
    <div class="w-full h-full py-4 border-b border-text-base flex items-center gap-2">
      <i
        :class="
          'text-neutral-600 text-body-md ' +
          icon
        " v-if="icon"></i>
      <input
        :type="type || 'text'"
        :placeholder="placeholder"
        :maxlength="max"
        :required="required"
        v-on="handlers"
        :value="modelValue"
        :autocomplete="autocomplete"
        :disabled="disabled"
        :spellcheck="spellcheck"
        :autocapitalize="autocapitalize"
        ref="input" 
        class="flex-1 bg-transparent outline-none border-none opacity-30 text-text-base text-body-lg font-heading font-medium uppercase placeholder:text-text-base placeholder:font-heading placeholder:font-medium placeholder:uppercase placeholder:text-body-lg" />
    </div>
    <p class="text-error text-body-sm" v-if="error">{{ error }}</p>
  </div>
</template>

<style scoped>
</style>
